import Backgroundetails from '@/components/Backgroundetails';
import Education from '@/components/Education';
import Experience from '@/components/Experience';
import React from 'react';

const Background: React.FC = () => {
  return (
 <div>
 <Backgroundetails/>
 <Experience/>
 <Education/>




 </div>

  );
};

export default Background; 